module.exports = __webpack_public_path__ + "static/media/paypal.f7bbbcec.svg";